import React from "react";
import { useLanguage } from "@/lib/LanguageContext";
import { SUPPORTED_LANGS, lookup } from "@/lib/i18n";
import { Globe } from "lucide-react";

/**
 * Sélecteur de langue compact (FR/EN/ES).
 * Variants:
 *   - "light" : pour les fonds clairs (SaaS landing, admin tenant)
 *   - "dark"  : pour les fonds sombres (super-admin)
 *   - "minimal" : icone + select sans texte
 */
export default function LanguageSwitcher({ variant = "light" }) {
  const { lang, setLang } = useLanguage();
  const isDark = variant === "dark";
  const className = isDark
    ? "bg-white/5 border border-white/10 text-white/80 hover:bg-white/10 focus:ring-sol-gold/40"
    : "bg-white/70 border border-sol-midnight/15 text-sol-midnight hover:bg-white focus:ring-sol-gold/40";

  return (
    <label
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1.5 text-xs cursor-pointer transition focus-within:ring-2 ${className}`}
      data-testid="language-switcher"
    >
      <Globe className="w-3.5 h-3.5 opacity-70" />
      <select
        aria-label="Language"
        value={lang}
        onChange={(e) => setLang(e.target.value)}
        className="bg-transparent border-0 outline-none focus:ring-0 text-xs font-medium uppercase tracking-wider cursor-pointer pr-1"
        data-testid="language-switcher-select"
      >
        {SUPPORTED_LANGS.map((l) => (
          <option key={l} value={l} className="text-sol-midnight bg-white">
            {lookup("common", `lang.${l}`, l, l.toUpperCase())}
          </option>
        ))}
      </select>
    </label>
  );
}
